var modalOverlay = document.querySelectorAll(".hero-video-popup-trigger"), videoPlayer, videoPlayInterval,modalVideo, iconBoxWidth, iconBoxHeight, iconHoverWidth, iconX, iconY, iconRX, demoVideoCTAText, enableJsApi = '';

if (modalOverlay) {
  for (var i = 0; i < modalOverlay.length; i++) {
    var modalVideoId = modalOverlay[i].getAttribute("data-video-id"),
      demoVideoPlayEvent = modalOverlay[i].getAttribute("data-video-btn-click-event"),
      demoVideoCloseEvent = modalOverlay[i].getAttribute("data-video-close-btn-event"),
      demoVideoFullScreenMode = modalOverlay[i].getAttribute("data-fullscreen-mode"),
      demoModalExtraClass = demoVideoFullScreenMode ? ['tingle-modal--fullscreen'] : [],
      ua = navigator.userAgent.toLowerCase(),
      isSafari = false,
      sandboxFlag = '';
      demoVideoCTAText = modalOverlay[i].getAttribute("data-video-modal-cta-text");

    // Detect browser for allow presentation sandbox flag
    try {
      isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
    }
    catch(err) {}
    isSafari = (isSafari || ((ua.indexOf('safari') != -1) && (!(ua.indexOf('chrome')!= -1) && (ua.indexOf('version/')!= -1))));
    sandboxFlag = isSafari ? '' : 'allow-presentation';

    modalOverlay[i].addEventListener("click", function(e) {
      e.preventDefault();
      if (modalVideoId) {
        modalVideo = new tingle.modal({
          focusAfterClosed: this,
          closeIconInverse: true,
          cssClass: demoModalExtraClass,
          onOpen: function () {
            //Play modal video Event
            if (demoVideoPlayEvent) {
              WebEventTracker.logEvent(EDS.webEvents, demoVideoPlayEvent, bsLib.extend({
                action: 'play'
              },
                ((popUpCSFOptions.vwoShow) ? { source: popUpCSFOptions.source } : {})
              ));
            }
          },
          onClose: function() {
            //Close modal video Event
            if (demoVideoCloseEvent) {
              WebEventTracker.logEvent(EDS.webEvents, demoVideoCloseEvent, bsLib.extend({
                action: 'close'
              },
                ((popUpCSFOptions.vwoShow) ? { source: popUpCSFOptions.source } : {})
              ));
            }

            modalVideo.destroy();
            destoryModalVideo();
          }
        });

        if (demoVideoCTAText) {
          enableJsApi = "&enablejsapi=1";
        }
        var modalContent =
          '<iframe class="video-frame-wrapper" id="video-frame-wrapper" width="100%" height="512" src="https://www.youtube.com/embed/' +
          modalVideoId +
          '?autoplay=1' + enableJsApi + '" frameborder="0" sandbox="allow-scripts allow-same-origin ' +
          sandboxFlag +
          '" allow = "autoplay; fullscreen"></iframe>';
        if (demoVideoCTAText) {
          modalContent +=
            '<div class="video-cta-wrapper"><button type="button" class="btn-primary col-md-3 btn-lg" id="modal-video-cta">' +
            demoVideoCTAText +
            "</button></div>";

          var youtubeApiScript = document.createElement("script");
          youtubeApiScript.setAttribute("class", "youtube-api");
          youtubeApiScript.src = "https://www.youtube.com/iframe_api";
          document.body.appendChild(youtubeApiScript);
        }
        modalVideo.setContent(modalContent);
        modalVideo.open();
        if (videoPlayer === null && demoVideoCTAText) {
          onYouTubeIframeAPIReady();
        }
      }
    });

    //mouse over events
    modalOverlay[i].addEventListener("mouseover", function( event ) {   
      var playIcons = document.querySelectorAll(".video-play-icon--img");
      for (var j = 0; j < playIcons.length; j++) {
        playIcons[j].setAttribute("src",playIcons[j].dataset.hoverImage);
      }
      if (demoVideoCTAText) {
        var animatedIcons = document.querySelectorAll(".animated-play-icon--img");
        for (var k = 0; k < animatedIcons.length; k++) {
          animatedIcons[k].children[0].setAttribute("rx", iconRX);
          animatedIcons[k].setAttribute("viewBox", "0 0 " + iconHoverWidth + " " + iconBoxHeight);
          document.querySelector(".play-icon-text").setAttribute("x", iconX);
          document.querySelector(".play-icon-text").setAttribute("y", iconY);
          document.querySelector(".play-icon-text").style.visibility = "visible";
          document.querySelector(".video-img-section").classList.add("expand");
        }
      }
    }, false);

    //mouse out events
    modalOverlay[i].addEventListener("mouseout", function( event ) {   
      var playIcons = document.querySelectorAll(".video-play-icon--img");
      for (var j = 0; j < playIcons.length; j++) {
        playIcons[j].setAttribute("src",playIcons[j].dataset.srcImage);
      }
      if (demoVideoCTAText) {
        var animatedIcons = document.querySelectorAll(".animated-play-icon--img");
        for (var k = 0; k < animatedIcons.length; k++) {
          animatedIcons[k].setAttribute("viewBox", "0 0 " + iconBoxWidth + " " + iconBoxHeight);
          document.querySelector(".video-img-section").classList.remove("expand");
          document.querySelector(".play-icon-text").style.visibility = "hidden";
        }
      }
    }, false);
  }
}
// This function will be called when the YouTube API is ready
function onYouTubeIframeAPIReady() {
  videoPlayer = new YT.Player("video-frame-wrapper" , {
    events: {
      'onReady': onPlayerReady
    }
  });
}

function onPlayerReady() {
  videoPlayInterval = setTimeout("calculateVideoPlayTime()", 1000);
}

function calculateVideoPlayTime() {
  if (videoPlayer && Object.keys(videoPlayer.playerInfo).length) {
    var currentTime = videoPlayer.playerInfo.currentTime; 
    if (currentTime.toFixed(2) > 15) {
      document.querySelector(".video-cta-wrapper").style.opacity = "1";
      document.getElementById("modal-video-cta").addEventListener("click", function (event) {
          modalVideo.destroy();
          destoryModalVideo();
          document.querySelector(".video-modal-cta").click();
      });
      clearTimeout(videoPlayInterval);
    } else {
      videoPlayInterval = setTimeout("calculateVideoPlayTime()", 1000);
    }
  } else {
    onYouTubeIframeAPIReady();
    videoPlayInterval = setTimeout("calculateVideoPlayTime()", 1000);
  }
}

function destoryModalVideo() {
  if (videoPlayer) {
    clearTimeout(videoPlayInterval);
    videoPlayer.destroy();
    document.querySelector(".youtube-api").remove();
    currentTime = null;
    videoPlayer = null;
  }
}

function updatePlayIconSize() {
  if (window.innerWidth > 980) {
    iconBoxWidth = "120"; 
    iconBoxHeight = "120"; 
    iconHoverWidth = "225";
    iconX    = "100";
    iconY    = "65";
    iconRX   = "60";
  } else if (window.innerWidth > 640)  {
    iconBoxWidth = "88"; 
    iconBoxHeight = "87"; 
    iconHoverWidth = "164";
    iconX    = "70";
    iconY    = "45";
    iconRX   = "45";
  } else {
    iconBoxWidth = "52"; 
    iconBoxHeight = "51"; 
    iconHoverWidth = "115";
    iconX    = "40";
    iconY    = "30";
    iconRX   = "25"; 
  }
  
  var animatedIcons = document.querySelectorAll(".animated-play-icon--img");
  for (var k = 0; k < animatedIcons.length; k++) {
    animatedIcons[k].setAttribute("viewBox", "0 0 " + iconBoxWidth + " " + iconBoxHeight);
  }
  document.querySelector('.video-img-section').style.visibility = "visible";
}

if (demoVideoCTAText) {
  window.onload   = updatePlayIconSize;
  window.onresize = updatePlayIconSize;
}